// Central helpers for building JSON-LD schemas across the site.
// All URLs use HTTPS without www. The LocalBusiness @id is the single stable
// reference used from Service.provider and BreadcrumbList origins.

export const SITE_ORIGIN = "https://rcps-terrassement.ch";
export const BUSINESS_ID = `${SITE_ORIGIN}/#business`;

/**
 * Build a BreadcrumbList schema.
 * @param {Array<{name:string, path:string}>} trail  e.g. [{name:"Accueil", path:"/"}, {name:"Entreprise", path:"/entreprise"}]
 */
export function buildBreadcrumb(trail) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: trail.map((step, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: step.name,
            item: `${SITE_ORIGIN}${step.path === "/" ? "/" : step.path.replace(/\/$/, "")}`,
        })),
    };
}

/**
 * Build a Service schema, linked to the LocalBusiness via `provider`.
 * @param {Object} params
 * @param {string} params.slug            e.g. "terrassement"
 * @param {string} params.name            e.g. "Terrassement"
 * @param {string} params.description
 * @param {string} params.serviceType     e.g. "Terrassement, fouilles et excavation"
 * @param {string} [params.image]
 */
export function buildService({ slug, name, description, serviceType, image }) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        "@id": `${SITE_ORIGIN}/prestations/${slug}#service`,
        name,
        serviceType,
        description,
        url: `${SITE_ORIGIN}/prestations/${slug}`,
        ...(image ? { image } : {}),
        provider: { "@id": BUSINESS_ID },
        areaServed: [
            { "@type": "AdministrativeArea", "name": "Canton de Genève" },
            { "@type": "AdministrativeArea", "name": "Canton de Vaud" },
            { "@type": "AdministrativeArea", "name": "Suisse romande" },
        ],
    };
}

/**
 * Build a FAQPage schema.
 * @param {string} pageUrl  Absolute URL of the page hosting the FAQ.
 * @param {Array<{question:string, answer:string}>} faqs
 */
export function buildFaqPage(pageUrl, faqs) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "@id": `${pageUrl}#faq`,
        mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: f.answer,
            },
        })),
    };
}
